export const LIST_LABEL = 'related_products';
